import React, { Component } from "react";
import { getProperty } from "../../../CommonFunctions";
import DetailTable from "../../2/Controls/DetailTable";
import DetailRow from "../../2/Controls/DetailRow";
import CustomTable from "../../2/Controls/CustomTable";
import { NO_IMAGE_FOUND } from "../../../actions/Util";

class ProductOverview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imgArray: []
        };
    }

    componentDidMount() {
        const { productData } = this.props;
        const images = getProperty(productData, "Images");
        const defaultImage = [NO_IMAGE_FOUND];

        this.setState({
            imgArray: images && images.length > 0
                ? images.map((img) => img.ImagePath)
                : defaultImage
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.productData !== this.props.productData) {
            const { productData } = this.props;
            const images = getProperty(productData, "Images");
            const defaultImage = [NO_IMAGE_FOUND];

            this.setState({
                imgArray: images && images.length > 0
                    ? images.map((img) => img.ImagePath)
                    : defaultImage
            });
        }
    }

    render() {
        const { productData, isSmartStore, registration, config } = this.props;
        const { imgArray } = this.state;

        const registrationData = registration.registration;
        const productCustomFields = config.CustomFields.filter(
            (customField) => customField.ModuleName === "Product"
        ) || [];

        const customFieldData = productCustomFields;

        console.log("customfields", customFieldData);
        console.log("productdata", productData);

        const hasStoreSpecificPrices = getProperty(productData, "StoreSpecificPrices") &&
            getProperty(productData, "StoreSpecificPrices").length > 0;

        const hasTaxPriceRange = getProperty(productData, "TaxPriceRange") &&
            getProperty(productData, "TaxPriceRange").length > 1;

        const hasAttributes = getProperty(productData, "Attributes") &&
            getProperty(productData, "Attributes").length > 0;

        const hasVariants = getProperty(productData, "Variants") &&
            getProperty(productData, "Variants").length > 0;

        const hasStoreSpecificQtys = getProperty(productData, "StoreSpecificQtys");

        const isInventoryProduct = getProperty(productData, "ProductTypeID") === 1 ||
            getProperty(productData, "ProductTypeID") === 2;

        return (
            <div
                style={{
                    padding: "16px",
                }}
            >
                <div>
                    <div
                        style={{
                            marginRight: "8px",
                        }}
                    >
                        {/* General Details */}
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))",
                                gap: "16px",
                            }}
                        >
                            <DetailTable title="General Details" mt="10px">
                                <DetailRow
                                    label="Name"
                                    value={getProperty(productData, "Name")}
                                />

                                <DetailRow
                                    label="Type"
                                    value={getProperty(productData, "ProductType")}
                                />

                                <DetailRow
                                    label="SKU"
                                    value={getProperty(productData, "SKU")}
                                />

                                <DetailRow
                                    label="Barcode"
                                    value={getProperty(productData, "BarCode")}
                                />

                                <DetailRow
                                    label="Category"
                                    value={getProperty(productData, "Category")}
                                />

                                <DetailRow
                                    label="Sub Category"
                                    value={getProperty(productData, "SubCategory")}
                                />

                                <DetailRow
                                    label="Brand"
                                    value={getProperty(productData, "Brand")}
                                />

                                <DetailRow
                                    label="Short Description"
                                    value={
                                        getProperty(productData, "Description")
                                            ? {
                                                __html: getProperty(
                                                    productData,
                                                    "Description"
                                                ),
                                            }
                                            : null
                                    }
                                />

                                <DetailRow
                                    label="Long Description"
                                    value={getProperty(
                                        productData,
                                        "LongDescription"
                                    )}
                                    type={"html"}
                                />
                            </DetailTable>

                            {/* Images */}
                            <div
                                style={{
                                    marginLeft: "8px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns:
                                            imgArray.length < 4
                                                ? "repeat(auto-fit,150px)"
                                                : "repeat(auto-fit,minmax(150px,1fr))",
                                        justifyContent:
                                            imgArray.length < 4
                                                ? "center"
                                                : "unset",
                                        gap: "20px",
                                        marginTop: "20px",
                                    }}
                                >
                                    {imgArray.map((image, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                position: "relative",
                                                transition: "transform 0.3s ease-in-out",
                                                border: "1px solid #d7d5e2",
                                                boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                                                borderRadius: "8px",
                                                overflow: "hidden",
                                            }}
                                        >
                                            <img
                                                src={image}
                                                alt={`Product ${index + 1}`}
                                                style={{
                                                    height: "150px",
                                                    width: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: "8px",
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Price & Taxes */}
                        <DetailTable title="Price & Taxes">
                            <DetailRow
                                label="Sold at specific stores only"
                                value={
                                    getProperty(
                                        productData,
                                        "AccessibleToSelectedStores"
                                    ) || "No"
                                }
                            />

                            <DetailRow
                                label="Some stores have different pricing"
                                value={
                                    getProperty(
                                        productData,
                                        "StoreSpecificPricing"
                                    ) || "No"
                                }
                                condition={
                                    !getProperty(
                                        productData,
                                        "AccessibleToSelectedStores"
                                    )
                                }
                            />
                        </DetailTable>

                        {hasStoreSpecificPrices && (
                            <div
                                style={{
                                    height: "auto",
                                    margin: "8px 0px",
                                    width: "600px",
                                }}
                            >
                                <CustomTable
                                    noShadow={true}
                                    columns={[
                                        {
                                            field: "store",
                                            headerName: "Store",
                                        },
                                        {
                                            field: "supplyPrice",
                                            headerName: "Supply Price",
                                            type: "currency",
                                        },
                                        {
                                            field: "marginPercentage",
                                            headerName: "Margin Percentage",
                                            align: "right",
                                        },
                                        {
                                            field: "marginAmount",
                                            headerName: "Margin Amount",
                                            type: "currency",
                                        },
                                        {
                                            field: "MSP",
                                            headerName: "MSP",
                                            type: "currency",
                                        },
                                        {
                                            field: "retailPrice",
                                            headerName: "Retail Price",
                                            type: "currency",
                                        },
                                        {
                                            field: "discPercentage",
                                            headerName: "Disc %",
                                            type: "currency",
                                        },
                                        {
                                            field: "discAmt",
                                            headerName: "Disc Amt",
                                            type: "currency",
                                        },
                                        {
                                            field: "MRP",
                                            headerName: "MRP",
                                            type: "currency",
                                        },
                                    ]}
                                    rows={getProperty(
                                        productData,
                                        "StoreSpecificPrices"
                                    ).map((row, index) => ({
                                        id: index,
                                        store: row.Store,
                                        marginPercentage: row.MarginPercentage,
                                        marginAmount: row.MarginAmount,
                                        supplyPrice: row.SupplyPrice,
                                        MSP: row.MSP,
                                        retailPrice: row.RetailPrice,
                                        discPercentage: row.DiscountPercentage,
                                        discAmt: row.DiscountAmount,
                                        MRP: row.MRP,
                                    }))}
                                />
                            </div>
                        )}

                        <DetailTable>
                            {!getProperty(
                                productData,
                                "AccessibleToSelectedStores"
                            ) && (
                                <>
                                    <DetailRow
                                        label="Supply Price"
                                        value={getProperty(
                                            productData,
                                            "SupplyPrice"
                                        )}
                                        type={"currency"}
                                        dontShowAtRightSide={true}
                                    />

                                    <DetailRow
                                        label="Margin %"
                                        value={getProperty(
                                            productData,
                                            "MarginPercentage"
                                        )}
                                        dontShowAtRightSide={true}
                                    />

                                    <DetailRow
                                        label="Margin Amount"
                                        value={getProperty(
                                            productData,
                                            "MarginAmount"
                                        )}
                                        type={"currency"}
                                        dontShowAtRightSide={true}
                                    />

                                    <DetailRow
                                        label="MSP"
                                        value={getProperty(productData, "MSP")}
                                        type={"currency"}
                                        dontShowAtRightSide={true}
                                    />

                                    <DetailRow
                                        label="Retail Price"
                                        value={getProperty(
                                            productData,
                                            "RetailPrice"
                                        )}
                                        type={"currency"}
                                        dontShowAtRightSide={true}
                                    />

                                    <DetailRow
                                        label="Discount %"
                                        value={`${getProperty(
                                            productData,
                                            "DiscountPercentage"
                                        ) || 0
                                            }%`}
                                        dontShowAtRightSide={true}
                                    />

                                    <DetailRow
                                        label="Discount Amount"
                                        value={getProperty(
                                            productData,
                                            "DiscountAmount"
                                        )}
                                        type={"currency"}
                                        dontShowAtRightSide={true}
                                    />

                                    <DetailRow
                                        label="MRP"
                                        value={getProperty(productData, "MRP")}
                                        type={"currency"}
                                        dontShowAtRightSide={true}
                                    />
                                </>
                            )}

                            <DetailRow
                                label="HSN SAC Code"
                                value={getProperty(
                                    productData,
                                    "HSNSACCode"
                                )}
                            />

                            <DetailRow
                                label="Charge taxes on this product"
                                value={getProperty(
                                    productData,
                                    "ChargeTaxOnProduct"
                                )}
                            />

                            <DetailRow
                                label="Tax Group"
                                value={getProperty(
                                    productData,
                                    "TaxGroup"
                                )}
                            />

                            <DetailRow
                                label="Tax based on retail price"
                                value={getProperty(
                                    productData,
                                    "PriceBasedTax"
                                )}
                            />
                        </DetailTable>

                        {hasTaxPriceRange && (
                            <div
                                style={{
                                    height: "auto",
                                    width: "350px",
                                    margin: "8px 0px",
                                }}
                            >
                                <CustomTable
                                    noShadow={true}
                                    columns={[
                                        {
                                            field: "TaxGroup",
                                            headerName: "Tax",
                                            width: "100px",
                                        },
                                        {
                                            field: "FromPrice",
                                            headerName: "From Price",
                                            align: "right",
                                        },
                                        {
                                            field: "ToPrice",
                                            headerName: "To Price",
                                            align: "right",
                                        },
                                    ]}
                                    rows={getProperty(
                                        productData,
                                        "TaxPriceRange"
                                    ).map((row) => ({
                                        FromPrice: row.FromPrice,
                                        ToPrice: row.ToPrice,
                                        TaxGroup: row.TaxGroup,
                                    }))}
                                />
                            </div>
                        )}

                        <DetailTable>
                            <DetailRow
                                label="Tax Inclusive (Purchase)"
                                value={getProperty(
                                    productData,
                                    "TaxInclusivePurchase"
                                )}
                                condition={getProperty(
                                    productData,
                                    "ChargeTaxOnProduct"
                                )}
                            />

                            <DetailRow
                                label="Tax Inclusive (Sales)"
                                value={getProperty(
                                    productData,
                                    "TaxInclusive"
                                )}
                                condition={getProperty(
                                    productData,
                                    "ChargeTaxOnProduct"
                                )}
                            />
                        </DetailTable>

                        {isInventoryProduct && (
                            <DetailTable title="Inventory">
                                <DetailRow
                                    label="Inventory Type"
                                    value={getProperty(
                                        productData,
                                        "InventoryType"
                                    )}
                                />

                                <DetailRow
                                    label="Unique Label"
                                    value={getProperty(
                                        productData,
                                        "UniqueLabel"
                                    )}
                                    condition={
                                        getProperty(
                                            productData,
                                            "InventoryType"
                                        ) === "Unique No"
                                    }
                                />

                                <DetailRow
                                    label="Batch No"
                                    value={getProperty(
                                        productData,
                                        "BatchTrackingBatchNoRequired"
                                    )}
                                    condition={
                                        getProperty(
                                            productData,
                                            "InventoryType"
                                        ) === "Batch No"
                                    }
                                />

                                <DetailRow
                                    label="MRP"
                                    value={getProperty(
                                        productData,
                                        "BatchTrackingMRPRequired"
                                    )}
                                    condition={
                                        getProperty(
                                            productData,
                                            "InventoryType"
                                        ) === "Batch No"
                                    }
                                />

                                <DetailRow
                                    label="Mfg Date"
                                    value={getProperty(
                                        productData,
                                        "BatchTrackingMfgDateRequired"
                                    )}
                                    condition={
                                        getProperty(
                                            productData,
                                            "InventoryType"
                                        ) === "Batch No"
                                    }
                                />

                                <DetailRow
                                    label="Exp Date"
                                    value={getProperty(
                                        productData,
                                        "BatchTrackingExpDateRequired"
                                    )}
                                    condition={
                                        getProperty(
                                            productData,
                                            "InventoryType"
                                        ) === "Batch No"
                                    }
                                />

                                <DetailRow
                                    label="Date Format"
                                    value={getProperty(
                                        productData,
                                        "BatchTrackingDateFormat"
                                    )}
                                    condition={
                                        getProperty(
                                            productData,
                                            "InventoryType"
                                        ) === "Batch No"
                                    }
                                />
                            </DetailTable>
                        )}

                        {isInventoryProduct && (
                            <>
                                {hasAttributes && (
                                    <div
                                        style={{
                                            height: "auto",
                                            margin: "8px 0px",
                                            width: "350px",
                                        }}
                                    >
                                        <CustomTable
                                            noShadow={true}
                                            columns={[
                                                {
                                                    field: "attribute",
                                                    headerName: "Attribute",
                                                },
                                                {
                                                    field: "values",
                                                    headerName: "Values",
                                                },
                                            ]}
                                            rows={getProperty(
                                                productData,
                                                "Attributes"
                                            ).map((attr) => ({
                                                attribute: attr.Attribute,
                                                values:
                                                    attr.AttributeValues.map(
                                                        (val) => val.value
                                                    ).join(", "),
                                            }))}
                                        />
                                    </div>
                                )}

                                {hasVariants && (
                                    <div
                                        style={{
                                            height: "auto",
                                            margin: "8px 0px",
                                        }}
                                    >
                                        <CustomTable
                                            noShadow={true}
                                            columns={[
                                                {
                                                    field: "Name",
                                                    headerName: "Variant Name",
                                                },
                                                {
                                                    field: "SKU",
                                                    headerName: "SKU",
                                                },
                                                {
                                                    field: "SupplyPrice",
                                                    headerName: "Supply Price",
                                                    type: "currency",
                                                },
                                                {
                                                    field: "MarginPercentage",
                                                    headerName: "Margin %",
                                                    type: "percentage",
                                                },
                                                {
                                                    field: "MarginAmount",
                                                    headerName: "Margin Amount",
                                                    type: "currency",
                                                },
                                                {
                                                    field: "MSP",
                                                    headerName: "MSP",
                                                    type: "currency",
                                                },
                                                {
                                                    field: "RetailPrice",
                                                    headerName: "Retail Price",
                                                    type: "currency",
                                                },
                                                {
                                                    field: "DiscountAmount",
                                                    headerName: "Discount Amount",
                                                    type: "currency",
                                                },
                                                {
                                                    field: "DiscountPercentage",
                                                    headerName: "Discount Percentage",
                                                    type: "percentage",
                                                },
                                                {
                                                    field: "MRP",
                                                    headerName: "MRP",
                                                    type: "currency",
                                                },
                                            ]}
                                            rows={
                                                getProperty(
                                                    productData,
                                                    "Variants"
                                                )
                                                    .filter(
                                                        (variant) =>
                                                            variant.IsDeleted ===
                                                            false
                                                    )
                                            }
                                        />
                                    </div>
                                )}

                                {hasStoreSpecificQtys && (
                                    <div
                                        style={{
                                            height: "auto",
                                            margin: "8px 0px",
                                            width: "350px",
                                        }}
                                    >
                                        <CustomTable
                                            noShadow={true}
                                            columns={[
                                                {
                                                    field: "StoreName",
                                                    headerName: "Store",
                                                },
                                                {
                                                    field: "MinQty",
                                                    headerName: "Min Qty",
                                                    align: "right",
                                                },
                                                {
                                                    field: "MaxQty",
                                                    headerName: "Max Qty",
                                                    align: "right",
                                                },
                                                {
                                                    field: "ReorderQty",
                                                    headerName: "Reorder Qty",
                                                    align: "right",
                                                },
                                            ]}
                                            rows={getProperty(
                                                productData,
                                                "StoreSpecificQtys"
                                            ).map((store) => ({
                                                StoreCode: store.StoreCode,
                                                StoreID: store.StoreID,
                                                StoreName: store.StoreName,
                                                InStockQty: store.InStockQty || "0",
                                                MinQty: store.MinQty || "0",
                                                MaxQty: store.MaxQty || "0",
                                                ReorderQty: store.ReorderQty || "0",
                                            }))}
                                        />
                                    </div>
                                )}
                            </>
                        )}

                        {/* Additional Settings */}
                        <DetailTable title="Additional Settings">
                            <DetailRow
                                label="Favourite"
                                value={getProperty(
                                    productData,
                                    "Favourite"
                                )}
                            />

                            <DetailRow
                                label="Allow price edit"
                                value={getProperty(
                                    productData,
                                    "AllowPriceEdit"
                                )}
                            />

                            <DetailRow
                                label="Discountable"
                                value={getProperty(
                                    productData,
                                    "AllowDiscount"
                                )}
                            />

                            <DetailRow
                                label="Allow tax change"
                                value={getProperty(
                                    productData,
                                    "AllowTaxChange"
                                )}
                            />

                            <DetailRow
                                label="Prompt for qty at the time billing"
                                value={getProperty(
                                    productData,
                                    "QtyPrompt"
                                )}
                            />

                            <DetailRow
                                label="Sequence"
                                value={getProperty(
                                    productData,
                                    "SequenceNo"
                                )}
                            />

                            <DetailRow
                                label="Packaging Charges"
                                value={getProperty(
                                    productData,
                                    "PackagingCharges"
                                )}
                            />

                            <DetailRow
                                label="Repack/Produce"
                                value={getProperty(
                                    productData,
                                    "RepackProduce"
                                )}
                            />

                            <DetailRow
                                label="BOM"
                                value={getProperty(productData, "BOM")}
                            />

                            <DetailRow
                                label="Manually specify product consumption"
                                value={getProperty(
                                    productData,
                                    "BOMManual"
                                )}
                            />

                            <DetailRow
                                label="Consumable"
                                value={getProperty(
                                    productData,
                                    "CanBeUsedAsConsumable"
                                )}
                            />

                            <DetailRow
                                label="Show as additional charges"
                                value={getProperty(
                                    productData,
                                    "ShowAsAdditionalCharges"
                                )}
                            />
                        </DetailTable>

                        {/* Additional Information */}
                        <DetailTable title="Additional Information">
                            <DetailRow
                                label={
                                    getProperty(
                                        customFieldData,
                                        "CustomField1Name"
                                    ) || "Custom Field 1"
                                }
                                value={getProperty(
                                    productData,
                                    "CustomField1"
                                )}
                            />

                            <DetailRow
                                label={
                                    getProperty(
                                        customFieldData,
                                        "CustomField2Name"
                                    ) || "Custom Field 2"
                                }
                                value={getProperty(
                                    productData,
                                    "CustomField2"
                                )}
                            />

                            <DetailRow
                                label={
                                    getProperty(
                                        customFieldData,
                                        "CustomField3Name"
                                    ) || "Custom Field 3"
                                }
                                value={getProperty(
                                    productData,
                                    "CustomField3"
                                )}
                            />

                            <DetailRow
                                label={
                                    getProperty(
                                        customFieldData,
                                        "CustomField4Name"
                                    ) || "Custom Field 4"
                                }
                                value={getProperty(
                                    productData,
                                    "CustomField4"
                                )}
                            />

                            <DetailRow
                                label={
                                    getProperty(
                                        customFieldData,
                                        "CustomField5Name"
                                    ) || "Custom Field 5"
                                }
                                value={getProperty(
                                    productData,
                                    "CustomField5"
                                )}
                            />

                            <DetailRow
                                label={
                                    getProperty(
                                        customFieldData,
                                        "CustomField6Name"
                                    ) || "Custom Field 6"
                                }
                                value={getProperty(
                                    productData,
                                    "CustomField6"
                                )}
                            />
                        </DetailTable>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProductOverview;